<mat-form-field appearance="outline" [floatLabel]="floatLabel" [attr.data-testid]="testId">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    type="tel"
    [formControl]="inner"
    mask="(000) 000 0000"
    placeholder="(000) 000 0000"
    [readonly]="readonly"
    [required]="required"
    autocomplete="off"
    (paste)="onPaste($event)"
    (blur)="onBlur()"
  />
  @if (inner.errors?.['required']) {
    <mat-error>Phone is required</mat-error>
  } @else if (inner.errors?.['invalidPhone']) {
    <mat-error>Enter a valid US phone number</mat-error>
  }
</mat-form-field>
